import type { ErrorEvent, EventHint } from '@sentry/react-router'

export function beforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  const error = hint.originalException
  if (error instanceof Error && error.cause instanceof Response && error.cause.status === 400) {
    let url: URL
    try {
      url = new URL(error.cause.url)
    } catch {
      return event
    }
    // Reown AppKit wallet search: 400 for search terms over 100 chars leaves an unhandled rejection.
    if (url.host === 'api.web3modal.org' && url.pathname === '/getWallets' && url.searchParams.get('search')) {
      return null
    }
  }
  return event
}
